// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"184":"b6beec15","1376":"bd874917","3966":"a03019cd","3973":"db95af21","6353":"db7d13c2","7707":"bd874917"}[chunkId] + ".chunk.css";
};